export const HatConstants = {
    hatSelector: ".nw_2021_hat",
    harWrapperSelector: ".nw_2021_hat-wrapper",
    dataScrollDown: "data-scroll-down",
    dataScrollUp: "data-scroll-up",
    scrollDownClass: "scroll_down",
    top: "top",
    bottom: "bottom",
    closeButton: ".multicolored-hat-expanded__close",
    expandButton: ".multicolored-hat-expanded__show-cta__button-desktop",
    expandButtonMobile: ".multicolored-hat-expanded__show-cta__button-mobile",
    expandSection: ".multicolored-hat-expanded",
    ctaVisible: "cta-visible",
    ctaHidden: "cta-hidden",
    hiddenHat: "hidden-hat",
    ctaAnimation: "cta-animation",
    ctaButtonAgree: ".multicolored-hat-expanded__wrapper__cta-buttons__btn--agree",
    ctaButtonDescription: ".multicolored-hat-expanded__wrapper__cta-buttons__btn--description",
    timerDateSelector: "[data-timer-hat]",
    timerSelector: ".hat-timer-countdown",
    clickIdDescription: "alternative_click",
};
